import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CategoryListModule } from '../../libs/category-list/category-list.module'
import { AthletesListComponent } from '../../people/athletes-list/athletes-list.component'
import { AthletesListResolver } from '../../people/athletes-list/athletes-list.resolver'
import { LeaguesListComponent } from './leagues-list.component'
import { ErrorModule } from '../../libs/error/error.module'
import { LazyLoadModule } from '../../../../projects/lazy-load/src/lib/lazy-load.module'
import { MapPipeModule } from '../../libs/map-pipe/map-pipe.module'
import { NoResultsModule } from '../../libs/no-results/no-results.module'
import { SharedModule } from '../../shared/shared.module'
import { LinkModule } from '../../libs/link/link.module'
import { AdhesionFooterModule } from 'src/app/libs/adhesion-footer/adhesion-footer.module'

@NgModule({
  imports: [
    CommonModule,
    ErrorModule,
    LazyLoadModule,
    MapPipeModule,
    NoResultsModule,
    SharedModule,
    LinkModule,
    AdhesionFooterModule
  ],
  declarations: [LeaguesListComponent]
})
export class LeaguesListModule {}
